import { createEnumHelper } from '@seiue/util'
import {
  ReflectionGenderEnum,
  ReflectionIdcardTypeEnum,
  ReflectionPupilTypeEnum,
  ReflectionRoleEnum,
  ReflectionStatusEnum,
} from 'packages/sdks-next/growp'

export const roleToLabel = createEnumHelper(() => ({
  [ReflectionRoleEnum.Teacher]: '教师',
  [ReflectionRoleEnum.Student]: '学生',
  [ReflectionRoleEnum.Guardian]: '家长',
  [ReflectionRoleEnum.Staff]: '职工',
  [ReflectionRoleEnum.Shadow]: '超管',
}))

export const genderToLabel = createEnumHelper(() => ({
  [ReflectionGenderEnum.M]: '男',
  [ReflectionGenderEnum.F]: '女',
}))

export const statusToLabel = createEnumHelper(() => ({
  [ReflectionStatusEnum.Normal]: '正常',
  [ReflectionStatusEnum.Archived]: '禁用',
}))

export const statusToColor = createEnumHelper(() => ({
  [ReflectionStatusEnum.Normal]: '#0A6CFF',
  [ReflectionStatusEnum.Archived]: '#F54545',
}))

export const idcardTypeToLabel = createEnumHelper(() => ({
  [ReflectionIdcardTypeEnum.Idcard]: '居民身份证',
  [ReflectionIdcardTypeEnum.MainlandPassForHkAndMacao]:
    '港澳居民来往内地通行证',
  [ReflectionIdcardTypeEnum.MainlandPassForTaiwan]: '台湾居民来往大陆通行证',
  [ReflectionIdcardTypeEnum.Passport]: '护照',
  [ReflectionIdcardTypeEnum.Other]: '其他',
}))

export const guardianTypeToLabel = createEnumHelper(() => ({
  [ReflectionPupilTypeEnum.Father]: '父亲',
  [ReflectionPupilTypeEnum.Mother]: '母亲',
  [ReflectionPupilTypeEnum.Other]: '其他',
}))
